import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MessageService } from '../_services/message.service';

import { Parameter } from '../_models/parameter';

import { Globals } from '../_globals/globals';


@Injectable({
  providedIn: 'root'
})

export class ParameterService {

  constructor(
    private http: HttpClient,
    // private httpParams: HttpParams,
    private globals: Globals,
    private messageService: MessageService
  ) {}

  getAllParameters(paramListIn: any): Observable<Parameter[]> {

    console.log('-->--> Ejecutando servicio getAllParameters');
    console.log(paramListIn);

    let params = new HttpParams();

    if (paramListIn !== null && paramListIn !== undefined) {
      for (const key in paramListIn) {
        // Para controlar que exista un elemento con esa key.
        if (paramListIn.hasOwnProperty(key)) {
          params = params.set(key, paramListIn[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    console.log('-->getAllParameters options:');
    console.log(options);

    return this.http.get<Parameter[]>(this.globals.apiUrl + '/parameters', options)
      .pipe(
        tap( data => this.log(' -> Parámetros obtenidos desde getAllParameters: ' + JSON.stringify(data))),
        catchError(this.handleError<Parameter[]>('getAllParameters', [])
      ));
  }

  updateParameter(parameterIn: Parameter): Observable<Parameter> {

    console.log('-->--> Ejecutando servicio updateParameter');
    console.log(parameterIn);
    console.log('---------------');

    let options = {};
    if (parameterIn.setup_prog === null) {
      options = { params: new HttpParams()
        .set('setup_prog', 'undefined') };
    } else {
      options = { params: new HttpParams()
        .set('setup_prog', parameterIn.setup_prog) };
    }

    return this.http.put<Parameter>(this.globals.apiUrl + '/parameter', parameterIn, options)
      .pipe(
        tap(  _ => this.log('updated parameter')),
        catchError(this.handleError<Parameter>('updateParameter', null)
      ));
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }
  // -------------------------

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

}
